module.exports = __webpack_public_path__ + "static/img/asco.b67daf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/asco.png
// module id = c7Xb
// module chunks = 0